<template>
    <b-modal id="ChangeInvoiceNumber-modal" hide-footer>
        <template #modal-title> Zmień nazwę faktury </template>
        <label>Numer faktury:</label>
        <input class="form-control" v-model="invoiceNumber" placeholder="Podaj numer faktury" />
        <div class="col align-self-end div-form-buttons-area">
            <button class="btn btn-primary" @click="SaveNewInvoiceNumber()">Zapisz</button>
        </div>
    </b-modal>
</template>

<script>
import InvoiceMixins from '../../../mixins/invoice'
import Toastr from "../../../mixins/toastr"

export default {
    name: "ChangeInvoiceNumberModal",
    mixins: [InvoiceMixins, Toastr],
    data() {
        return {
            rawMaterialDeliveryId: 0,
            invoiceNumber: ""
        }
    },
    methods: {
        OpenModalForChangingInvoiceNumber(item) {
            this.invoiceNumber = item.invoiceNumber;
            this.rawMaterialDeliveryId = item.deliveryId;
            this.$bvModal.show("ChangeInvoiceNumber-modal");
        },
        SaveNewInvoiceNumber() {
            const that = this;
            this.changeInvoiceNumber(this.rawMaterialDeliveryId, this.invoiceNumber)
                .then(function () {
                    that.$bvModal.hide("ChangeInvoiceNumber-modal");
                    that.$emit("InvoiceNumberWasUpdated",
                        {
                            rawMaterialDeliveryId: that.rawMaterialDeliveryId,
                            invoiceNumber: that.invoiceNumber
                        }
                    )
                    that.rawMaterialDeliveryId = 0;
                    that.invoiceNumber = "";
                })
                .catch(function (e) {
                    //TODO: Error handling
                    console.log(e);
                    that.DisplayError("Błąd!", e);
                });
        },
    },
};
</script>
